// Via https://css-tricks.com/how-to-animate-the-details-element-using-waapi/
// Modified to animate the content instead of the details element itself

class Accordion {
	constructor(el) {
		// Store the <details> element
		this.el = el;
		// Store the <summary> element
		this.summary = el.querySelector("summary");
		// Store the content element
		// We are selecting <details> elements who have one child following the <summary>
		this.content = el.querySelector("summary + *:last-child");
		if (this.content === null) {
			return false;
		}

		// Check and see if this browser supports the animation API
		if (typeof this.content.animate !== "function") {
			return false;
		}

		// Store the animation object (so we can cancel it if needed)
		this.animation = null;
		// Store if the element is closing
		this.isClosing = false;
		// Store if the element is expanding
		this.isExpanding = false;
		// Detect user clicks on the summary element
		this.summary.addEventListener("click", (e) => this.onClick(e));
	}

	onClick(e) {
		// Stop default behaviour from the browser
		e.preventDefault();
		// Check if the element is being closed or is already closed
		if (this.isClosing || !this.el.open) {
			this.open();
			// Check if the element is being openned or is already open
		} else if (this.isExpanding || this.el.open) {
			this.shrink();
		}
	}

	shrink() {
		// Set the element as "being closed"
		this.isClosing = true;

		// Store the current height of the element
		const startHeight = `${this.content.offsetHeight}px`;
		// Calculate the height of the summary
		const endHeight = `0px`;

		// If there is already an animation running
		if (this.animation) {
			// Cancel the current animation
			this.animation.cancel();
		}

		// Start a WAAPI animation
		this.animation = this.content.animate(
			{
				// Set the keyframes from the startHeight to endHeight
				height: [startHeight, endHeight],
				opacity: [1, 0],
			},
			{
				duration: 250,
				easing: "ease",
			}
		);

		// When the animation is complete, call onAnimationFinish()
		this.animation.onfinish = () => this.onAnimationFinish(false);
		// If the animation is cancelled, isClosing variable is set to false
		this.animation.oncancel = () => (this.isClosing = false);
	}

	open() {
		// Force the [open] attribute on the details element
		this.el.open = true;
		// Wait for the next frame to call the expand function
		window.requestAnimationFrame(() => this.expand());
	}

	expand() {
		// Set the element as "being expanding"
		this.isExpanding = true;
		// Get the current fixed height of the element
		const startHeight = `0px`;
		// Calculate the open height of the element (summary height + content height)
		const endHeight = `${this.content.offsetHeight}px`;

		// If there is already an animation running
		if (this.animation) {
			// Cancel the current animation
			this.animation.cancel();
		}

		// Start a WAAPI animation
		this.animation = this.content.animate(
			{
				// Set the keyframes from the startHeight to endHeight
				height: [startHeight, endHeight],
				opacity: [0, 1],
			},
			{
				duration: 250,
				easing: "ease",
			}
		);
		// When the animation is complete, call onAnimationFinish()
		this.animation.onfinish = () => this.onAnimationFinish(true);
		// If the animation is cancelled, isExpanding variable is set to false
		this.animation.oncancel = () => (this.isExpanding = false);
	}

	onAnimationFinish(open) {
		// Set the open attribute based on the parameter
		this.el.open = open;
		// Clear the stored animation
		this.content.animation = null;
		// Reset isClosing & isExpanding
		this.isClosing = false;
		this.isExpanding = false;
		// Remove the fixed height
		this.content.style.height = "";
	}
}

var animation_allowed = window.matchMedia("(prefers-reduced-motion: no-preference)");
if (animation_allowed.matches) {
	var detailsElements = document.querySelectorAll("details");
	detailsElements.forEach(function (el) {
		new Accordion(el);
	});
}
